import { z } from 'zod';

const commonJwtPayloadSchema = z.object({
  sub: z.string(),
  aud: z
    .union([z.string(), z.array(z.string())])
    .transform((val) => (typeof val === 'string' ? [val] : val)),
  iat: z.number().transform((val) => new Date(val * 1000)),
  exp: z.number().transform((val) => new Date(val * 1000)),
  scope: z
    .string()
    .optional()
    .default('')
    .transform((val) => val.split(' ')),
  azp: z.string().optional(),
  iss: z.string(),
  org_id: z.string().optional(),
  tempo_org_id: z.string().optional(),
  tempo_org_name: z.string().optional(),
});

export const userJwtPayloadSchema = commonJwtPayloadSchema.extend({
  gty: z.undefined().optional(),
  email: z.string(),
  tempo_user_id: z.string(),
  connection_name: z.string().optional(),
});

export const clientCredentialsJwtPayloadSchema = commonJwtPayloadSchema.extend({
  gty: z.literal('client-credentials'),
});

export const jwtPayloadSchema = z.discriminatedUnion('gty', [
  clientCredentialsJwtPayloadSchema,
  userJwtPayloadSchema,
]);
